var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.isfaq)?_c('faqdetails'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }